export const FirstTimeCustomerPopup = () => {
  return null; // Disabled per user request
};
